import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const AssetsByCategory = () => {
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState({
    series: [],
    categories: [],
    colors: []
  });

  useEffect(() => {
    fetchStatistics();
  }, []);

  // Color mapping for each category
  const getCategoryColor = (category) => {
    const colorMap = {
      'Vehicles': '#3B82F6',              // Blue
      'Equipments': '#F59E0B',            // Orange
      'Furniture and fixture': '#22C55E'  // Green
    };
    return colorMap[category] || '#4189dd'; // Default to dusty blue
  };

  const fetchStatistics = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem('authToken');

      if (!apiUrl || !token) {
        setLoading(false);
        return;
      }

      const response = await fetch(`${apiUrl}/assets/statistics`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data.success && data.data.by_category) {
        const categories = data.data.by_category.map(item => item.asset_category);
        const series = data.data.by_category.map(item => item.count);
        const colors = data.data.by_category.map(item => 
          getCategoryColor(item.asset_category)
        );
        
        setChartData({
          series: series,
          categories: categories,
          colors: colors
        });
      }
    } catch (err) {
      console.error('Failed to fetch statistics:', err);
    } finally {
      setLoading(false);
    }
  };

  const chartOptions = {
    chart: {
      type: 'donut',
      height: 350,
      toolbar: {
        show: false
      }
    },
    labels: chartData.categories,
    colors: chartData.colors.length > 0 ? chartData.colors : ['#4189dd', '#97cbff', '#073656'],
    legend: {
      position: 'bottom',
      fontSize: '14px',
      fontFamily: 'Inter, sans-serif',
      markers: {
        width: 10,
        height: 10,
        radius: 12
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toFixed(0) + "%"
      }
    },
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total Assets',
              fontSize: '16px',
              fontWeight: 600,
              color: '#64748B',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
              }
            }
          }
        }
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 300
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  return (
    <div className='col-xxl-4 col-xl-6'>
      <div className='card h-100'>
        <div className='card-body p-24'>
          <h6 className='mb-20 fw-bold text-lg'>Assets by Category</h6>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : chartData.series.length > 0 ? (
            <ReactApexChart 
              options={chartOptions} 
              series={chartData.series} 
              type="donut" 
              height={350} 
            />
          ) : (
            <div className="text-center py-5 text-secondary-light">
              No asset data available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssetsByCategory;

